import { Link } from "react-router-dom";
import React from "react";
import BasketCount from "./BasketCount";

function Header(props) {
  return (
    <div className="header">
      <h1>Media Store App</h1>
      <div className="breadcrumb">
        <ul>
          <li>
            <Link to="/" id="homelink" onClick={props.resetList}>         
              Home
            </Link>
          </li>
          <li className="active">
            <Link to="/about" id="aboutlink">
              About
            </Link>
          </li>
          <li>
            <Link to="/basket" id="basketlink">
              Basket<span className="count"> (
              <BasketCount
                basket={props.basket}
                basketCount={props.basketCount}
              />
              )</span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Header;